<div class="grid">
  <app-numberplate-scan title="Einfahrt 1" [scanResult]="entrance1"></app-numberplate-scan>
  <app-numberplate-scan title="Ausfahrt 1"[scanResult]="leave1"></app-numberplate-scan>
  <app-numberplate-scan title="Einfahrt 2"[scanResult]="entrance2"></app-numberplate-scan>
  <app-numberplate-scan title="Ausfahrt 2"[scanResult]="leave2"></app-numberplate-scan>
</div>
